{
  "name": "finitio",
  "version": "2.0.1-rc6",
  "description": "Finitio is a language for capturing information structure.",
  "author": "Louis Lambeau <louislambeau@gmail.com>",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/llambeau/finitio.js"
  },
  "files": [
    "dist",
    "package.json"
  ],
  "exports": {
    ".": {
      "require": "./dist/finitio.js",
      "import": "./dist/finitio.mjs",
      "types": "./dist/finitio.d.ts"
    }
  },
  "main": "./dist/finitio.js",
  "module": "./dist/finitio.mjs",
  "types": "./dist/finitio.d.ts",
  "keywords": [
    "finitio",
    "typing",
    "system",
    "json",
    "serialization",
    "validation"
  ],
  "analyze": true,
  "bin": {
    "finitio": "./bin/finitio-js",
    "finitio-js": "./bin/finitio-js"
  },
  "scripts": {
    "prepack": "npm run build",
    "prepare": "npm run build",
    "build": "grunt build",
    "test": "npm run test:unit && npm run test:integration && npm run test:acceptance",
    "test:unit": "ts-mocha specs/unit --extension ts --extension js --recursive",
    "test:unit:watch": "ts-mocha --watch specs/unit --extension ts --extension js --recursive",
    "test:integration": "ts-mocha specs/integration --extension ts --extension js --recursive",
    "test:integration:watch": "ts-mocha specs/integration --extension ts --extension js --recursive --watch",
    "test:acceptance": "grunt test:acceptance",
    "browserify": "grunt browserify",
    "lint": "eslint --ext .js,.jsx,.ts src",
    "lint:fix": "eslint --ext .js,.jsx,.ts --fix src"
  },
  "dependencies": {
    "@enspirit/ts-gen-dsl": "^0.0.3",
    "commander": "^12.0.0"
  },
  "devDependencies": {
    "@enspirit/eslint-config-node": "^0.1.5",
    "@types/mocha": "^10.0.6",
    "@typescript-eslint/eslint-plugin": "^6.12.0",
    "@typescript-eslint/parser": "^6.12.0",
    "browserify": "~17.0.0",
    "cucumber": "~6.0.7",
    "eslint": "^7.32.0",
    "eslint-plugin-no-autofix": "1.2.3",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "grunt": "~1.4.1",
    "grunt-browserify": "~6.0.0",
    "grunt-cli": "^1.4.3",
    "grunt-contrib-clean": "~2.0.0",
    "grunt-contrib-jshint": "~3.1.1",
    "grunt-contrib-uglify": "~5.0.1",
    "grunt-contrib-watch": "~1.1.0",
    "grunt-cucumber": "^0.3.0",
    "grunt-fixtures2js": "~0.1.3",
    "grunt-mocha-test": "~0.13.3",
    "grunt-shell": "~3.0.1",
    "mocha": "^9.1.3",
    "mocha-junit-reporter": "^2.0.2",
    "sinon": "^17.0.1",
    "sinon-chai": "^3.7.0",
    "peggy": "^4.0.0",
    "should": "^13.2.3",
    "ts-mocha": "^10.0.0",
    "tsup": "^8.0.2",
    "typescript": "^5.3.3",
    "underscore": "~1.13.1"
  }
}
